// extracted by mini-css-extract-plugin
export default {"wrapper":"MultiSelect_wrapper__7d+T3","hasValue":"MultiSelect_hasValue__Du-yg"};